export * from './People2Icon';
export * from './People2Icon16Light';
export * from './People2Icon16Regular';
export * from './People2Icon16Solid';
export * from './People2Icon20Light';
export * from './People2Icon20Regular';
export * from './People2Icon20Solid';
export * from './People2Icon24Regular';
export * from './People2Icon24Solid';
export * from './People2Icon32Regular';
export * from './People2Icon64Regular';
